import '../../../../icons'
import platformRedirect from '../../../../mixins/platformRedirect'
import VueNotifications from 'vue-notifications'

export default {
  name: 'GoogleButton',
  mixins: [platformRedirect],
  notifications: {
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showErrorMsg: {
      type: VueNotifications.types.warn
    }
  },
  mounted () {

  },

  //beaware of payload changes
  methods: {
    haveKey (object, key) {
      return object ? hasOwnProperty.call(object, key) : false
    },
    emitValues (googleUser) {
      this.$emit('user', googleUser)
    },
    signInGoogle () {
      this.$gAuth.signIn()
        .then(GoogleUser => {
          return this.$http.post('user/login/social/google', {
            access_token: GoogleUser.uc.access_token,
            id_token: GoogleUser.uc.id_token
          })
        })
        .then(response => {
          if (this.haveKey(response.body, 'token')) {
            return this.setTokenAndRedirect(response.body.token)
          }
          if (response.body.is_user) {
            return this.showErrorMsg({
              title: this.$i18n.t('Your account is not verified'),
              message: this.$i18n.t(response.body.message)
            })
          }
          this.showInfoMsg({
            title: this.$i18n.t('Your google account dont have the fields needed'),
            message: this.$i18n.t('The sign up form is filled with your facebook profile data.')
          })

          this.emitValues(response.body.options)
        })
        .catch(error => {
          console.log(error) /// Show errors somehow
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/buttons/google/google.js